import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { productDetail } from "../api.services.js/product";
import { useState } from "react";
import { requestQuote } from "../api.services.js/others";
import swal from "sweetalert";
import { useRouter } from "next/router";
import Head from "next/head";
import { gtagConversionEvent } from "../gtag";
import { useEffect } from "react";
import cookie from "js-cookie";

export const getServerSideProps = async (context) => {
  let productSlug = context.query.pid;
  if (!productSlug) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }
  const getProductSetail = await productDetail({
    urlKey: productSlug,
  });
  return {
    props: { getProductSetail, urlKey: productSlug ? productSlug : null },
  };
};
const PincodeBasedQuotation = (props) => {
  const router = useRouter();
  const [product, setProduct] = useState(
    props?.getProductSetail?.data?.products?.items[0]
  );
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    iam: "Homeowner",
    phone: "",
    email: "",
    area: "",
    address1: "",
    address2: "",
    state: "",
    city: "",
    pincode: cookie.get("pincode"),
  });
  const [formDataError, setFormDataError] = useState({
    name: "",
    phone: "",
    email: "",
    area: "",
    address1: "",
    state: "",
    city: "",
    pincode: "",
  });
  const [indianStates, setIndianStates] = useState([
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
  ]);

  useEffect(() => {
    if (!router.query.pid || !product?.name) {
      router.push("/404");
    }
  }, []);

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    let error = {};
    if (!formData.name) {
      error.name = "Name is required";
    }
    if (!formData.phone) {
      error.phone = "Phone is required";
    }
    if (formData.phone.length != 10) {
      error.phone = "The phone number should contain 10 digits";
    }
    if (!formData.email) {
      error.email = "Email is required";
    }
    //  if(!formData.city){
    //   error.city ="City is required"
    //  }
    //  if(!formData.address1){
    //   error.address1 = "Address is required"
    //  }
    //  if(!formData.area){
    //   error.area = "Area is required"
    //  }
    //  if(!formData.state){
    //   error.state ="State is required"
    //  }
    if (!formData.pincode) {
      error.pincode = "Pincode is required";
    }
    if (formData.pincode.length != 6) {
      error.pincode = "Invalid pincode";
    }
    setFormDataError(error);

    if (Object.keys(error).length === 0) {
      setLoading(true);
      //gtagConversionEvent()
      let response = await requestQuote({
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        city: formData.city,
        iama: formData.iam,
        address1: formData.address1,
        address2: formData.address2,
        areatobetiled: formData.area,
        state: formData.state,
        pincode: formData.pincode,
        productid: product.id,
        page_url: (JSON.parse(localStorage.getItem("visitedPages")) || [])
          .slice(-10)
          .join(" => "),
        First_Visited_URL: JSON.parse(localStorage.getItem("firstVistedPage")),
      });
      setLoading(false);
      if (response?.data?.request_price_quote?.msg) {
        swal(response?.data?.request_price_quote?.msg);
        setFormData({
          name: "",
          iam: "Homeowner",
          phone: "",
          email: "",
          area: "",
          address1: "",
          address2: "",
          state: "",
          city: "",
          pincode: "",
        });
        router.push(`/${props.urlKey}`);
      } else if (response.message) {
        swal(response.message);
      } else {
        swal("Something went wrong, please try again after some time");
      }
    }
  };

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Pincode based quotation",
        "item": "https://www.orientbell.com/pincode-based-quotation"
      }]
      }`,
    };
  };
  return (
    <>
      <Head>
        <title> Pincode based quotation</title>
        <meta name="title" content="Pincode based quotation" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={breadCrumbSchema()}
        />
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <div className="PincodeBasedQuotation">
        <Container>
          <h2 className="productpage_title">
            <span>Get a Price Quote for your requirements</span>
          </h2>
          <p>
            Fill the details below for getting a price quotation from the
            nearest store
          </p>
          <p>Tile selected : {product?.name}</p>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Row className="align-items-center">
              <Col md={6} className="mb-3">
                <Form.Label htmlFor="name">Name</Form.Label>
                <Form.Control name="name" onChange={onChangeInput} />
                {formDataError.name && (
                  <Form.Text className="text-danger">
                    {formDataError.name}
                  </Form.Text>
                )}
              </Col>
              {/* <Col md={6} className='mb-3'>
                <Form.Label htmlFor="email" >
                I am
                </Form.Label>
                <Form.Select name="iam" aria-label="Select Option" onChange={onChangeInput}>
                <option value="Homeowner">Homeowner</option>
                  <option value="Homeowner">Homeowner</option>
                  <option value="Architect/Interior Designer">Architect/Interior Designer</option>
                  <option value="Builder">Builder</option>
                  <option value="Contractor">Contractor</option>
                  <option value="Mason">Mason</option>
                  <option value="Others">Others</option>
                </Form.Select>
                {formDataError.iam && <Form.Text className="text-danger">{formDataError.iam}</Form.Text>}
                </Col> */}
              <Col md={6} className="mb-3">
                <Form.Label htmlFor="name">Mobile No.</Form.Label>
                <Form.Control
                  name="phone"
                  type="Number"
                  onChange={onChangeInput}
                />
                {formDataError.phone && (
                  <Form.Text className="text-danger">
                    {formDataError.phone}
                  </Form.Text>
                )}
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label htmlFor="name">Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={onChangeInput}
                />
                {formDataError.email && (
                  <Form.Text className="text-danger">
                    {formDataError.email}
                  </Form.Text>
                )}
              </Col>
              {/* <Col md={6} className='mb-3'>
                <Form.Label htmlFor="name" >
                Area to be tiled (in square feet)
                </Form.Label>
                <Form.Control  name="area" type='Number' onChange={onChangeInput}/>
                {formDataError.area && <Form.Text className="text-danger">{formDataError.area}</Form.Text>}

                </Col> */}
              {/* <Col md={6} className='mb-3'>
                <Form.Label htmlFor="name" >
                Address Line 1
                </Form.Label>
                <Form.Control name="address1" as="textarea" rows={3} onChange={onChangeInput}/>
                {formDataError.address1 && <Form.Text className="text-danger">{formDataError.address1}</Form.Text>}

                </Col> */}
              {/* <Col md={6} className='mb-3'>
                <Form.Label htmlFor="name" >
                Address Line 2
                </Form.Label>
                <Form.Control name="address2"  as="textarea" rows={3} onChange={onChangeInput}/>
                </Col> */}
              {/* <Col md={6} className='mb-3'>
                <Form.Label htmlFor="email" >
                State
                </Form.Label>
                <Form.Select name="state" aria-label="Select Option" onChange={onChangeInput}>
                <option value="">State</option>
                {indianStates.sort().map((cur, index)=>{
                  return(
                <option value={cur} key={index}>{cur}</option>

                  )
                })}
                </Form.Select>
                {formDataError.state && <Form.Text className="text-danger">{formDataError.state}</Form.Text>}

                </Col> */}
              {/* <Col md={6} className='mb-3'>
                <Form.Label htmlFor="name" >
                City
                </Form.Label>
                <Form.Control onChange={onChangeInput} name="city"/>
                {formDataError.city && <Form.Text className="text-danger">{formDataError.city}</Form.Text>}

                </Col> */}
              <Col md={6} className="mb-3">
                <Form.Label htmlFor="name">Pincode</Form.Label>
                <Form.Control
                  onChange={onChangeInput}
                  type="Number"
                  name="pincode"
                />
                {formDataError.pincode && (
                  <Form.Text className="text-danger">
                    {formDataError.pincode}
                  </Form.Text>
                )}
              </Col>
              <Col xs={12} className="mt-4">
                {loading ? (
                  <Button className="primary">Submitting</Button>
                ) : (
                  <Button className="primary" type="submit">
                    Submit
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default PincodeBasedQuotation;
